<template>
  <tr>
    <form-item-label label="現住所" :required="true" />
    <complemented-text-form
      v-if="complementedTextOpened"
      :text="complementedText"
      @open="openForm"
      :editable="true"
    />
    <td v-if="!complementedTextOpened" colspan="3">
      <div class="m3p-contact__adress m3p-contact__input_2column">
        <prefecture-form :selectivePrefectureList="selectivePrefectureList" />
        <address-form
          v-if="selectiveCityList"
          :selectiveCityList="selectiveCityList"
        />
      </div>
      <div class="m3p-searchbox__small">
        ※お住まいの地域でお仕事を探されている方は都道府県以降もご記入ください
      </div>
    </td>
  </tr>
</template>

<script setup>
import { computed, onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';
import ComplementedTextForm from '@component_path/pages/pc/positions/show/common_components/form_element/ComplementedText';
import FormItemLabel from '@component_path/pages/pc/positions/show/common_components/form_element/FormItemLabel';
import PrefectureForm from '@component_path/pages/pc/positions/show/inquiry_form/components/inquiry_form_item/Prefecture';
import AddressForm from '@component_path/pages/pc/positions/show/inquiry_form/components/inquiry_form_item/Address';

const store = useStore();

const CITY_CODE_API_PATH = '/api/v2/public/data/cities';

const props = defineProps({
  prefectureMaster: {
    type: Array,
    required: true
  }
});

const complementedTextOpened = ref(false);
const selectiveCityList = ref();

const prefectureId = computed(
  () => store.state.positionInquiryMail.formData.prefecture_id
);
const address = computed(
  () => store.state.positionInquiryMail.formData.address
);
const selectivePrefectureList = computed(() =>
  props.prefectureMaster.map(prefecture => ({
    value: prefecture.code,
    text: prefecture.text
  }))
);

const complementedText = computed(() => {
  if (prefectureId.value) {
    const selectedPrefecture = selectivePrefectureList.value.find(
      prefecture => prefecture.value === prefectureId.value
    );
    return `${selectedPrefecture.text} ${address.value || ''}`;
  } else {
    return '';
  }
});

const updateSelectiveCityList = () => {
  axios
    .get(CITY_CODE_API_PATH, {
      params: { prefecture_id: prefectureId.value }
    })
    .then(res => {
      selectiveCityList.value = Object.keys(res.data).map(key => {
        const cityCode = res.data[key];
        return {
          value: cityCode.name,
          text: cityCode.name
        };
      });
    })
    .catch(res => alert(res.error));
};
const openForm = () => (complementedTextOpened.value = false);

watch(prefectureId, () => {
  if (prefectureId.value) {
    updateSelectiveCityList();
  } else {
    selectiveCityList.value = [];
  }
  store.dispatch('positionInquiryMail/setAddress', '');
});

watch(complementedTextOpened, () => {
  if (prefectureId.value) {
    updateSelectiveCityList();
  }
});

onMounted(() => {
  if (prefectureId.value) {
    complementedTextOpened.value = true;
  }
});

if (prefectureId.value) {
  updateSelectiveCityList();
}
</script>
